var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuality3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_87_589)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.3334 21.3333C38.488 21.3333 42.6667 17.1546 42.6667 12C42.6667 6.8453 38.488 2.66663 33.3334 2.66663C28.1787 2.66663 24 6.8453 24 12C24 17.1546 28.1787 21.3333 33.3334 21.3333ZM13.3334 45.3333C13.3334 35.024 21.6907 26.6667 32 26.6667C42.3094 26.6667 50.6667 35.024 50.6667 45.3333L32 53.3333L13.3334 45.3333Z",
    fill: "#CFD7E9",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.6667 40C51.8213 40 56 35.8213 56 30.6667C56 25.512 51.8213 21.3333 46.6667 21.3333C41.512 21.3333 37.3333 25.512 37.3333 30.6667C37.3333 35.8213 41.512 40 46.6667 40ZM24 64C24 52.7302 33.136 43.5942 44.4058 43.5942C55.6756 43.5942 64.8116 52.7302 64.8116 64H24Z",
    fill: "#26DDF9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 40C25.1547 40 29.3333 35.8213 29.3333 30.6667C29.3333 25.512 25.1547 21.3333 20 21.3333C14.8453 21.3333 10.6667 25.512 10.6667 30.6667C10.6667 35.8213 14.8453 40 20 40ZM0 64C0 52.7302 9.13599 43.5942 20.4058 43.5942C31.6756 43.5942 40.8116 52.7302 40.8116 64H0Z",
    fill: "#26DDF9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 64.0001H40.8116C40.8116 57.2154 37.5004 51.204 32.4058 47.4939C27.3112 51.204 24 57.2154 24 64.0001Z",
    fill: "#010304"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_87_589"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuality3);
export default __webpack_public_path__ + "static/media/quality_3.0474c9a3ca5adadfc55c2dbbccdaf6f8.svg";
export { ForwardRef as ReactComponent };